import React from 'react';
import type { FiscalDocument } from '../../types/fiscal';

interface FiscalFormProps {
  onSubmit: (data: FiscalDocument) => void;
  onCancel: () => void;
}

const FiscalForm: React.FC<FiscalFormProps> = ({ onSubmit, onCancel }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // This is a placeholder document - you'll want to get actual form values
    const document: FiscalDocument = {
      id: '',
      number: '',
      date: new Date(),
      value: 0,
      status: 'pending'
    };
    onSubmit(document);
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Nova Nota Fiscal Eletrônica</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="number" className="block text-sm font-medium text-gray-700">
            Número da NF-e
          </label>
          <input
            type="text"
            id="number"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div>
          <label htmlFor="date" className="block text-sm font-medium text-gray-700">
            Data de Emissão
          </label>
          <input
            type="date"
            id="date"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div>
          <label htmlFor="value" className="block text-sm font-medium text-gray-700">
            Valor Total
          </label>
          <input
            type="number"
            id="value"
            step="0.01"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Salvar
          </button>
        </div>
      </form>
    </div>
  );
};

export default FiscalForm;